import { Component, Input, OnInit } from '@angular/core';
import { ProductsWithPriceAndNoteLabels, ProductWithPriceAndAdditionalInfo } from '../../models/types';
import { getStudentPreparationLabels } from '../../utils/table-utils';
import { Company, CompanyEnum } from '../../models/company.model';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { PriceAndNoteTableComponent } from '../price-and-note-table/price-and-note-table.component';
import { PriceListStudentPreparation } from '../../models/pricelist-student-preparation.model';
import { Currency } from '../../models/currency.model';

@Component({
  standalone: true,
  imports: [TableHeaderComponent, PriceAndNoteTableComponent],
  selector: 'lx-price-lists-portal-student-preparation-table',
  templateUrl: './student-preparation-table.component.html',
  styleUrls: ['./student-preparation-table.component.scss'],
})
export class StudentPreparationTableComponent implements OnInit {
  @Input() studentPreparations: PriceListStudentPreparation[] | undefined;
  @Input() currency: Currency | undefined;
  @Input() company: Company = CompanyEnum.KIL;

  dataSource: ProductWithPriceAndAdditionalInfo[] = [];
  columnLabels: ProductsWithPriceAndNoteLabels | undefined;

  ngOnInit(): void {
    this.columnLabels = getStudentPreparationLabels();
    this.dataSource = this.studentPreparations?.map(({ program, note, fee }) => ({
      name: program,
      price: fee,
      additionalInfo: note,
    }));
  }
}
